import { render } from "./rr-star-ratings.vue?vue&type=template&id=7f79cebb"
import script from "./rr-star-ratings.vue?vue&type=script&lang=js"
export * from "./rr-star-ratings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__